<template>
  <v-card id="alerts-dialog">
    <v-card-title class="i-dialog-header-div c-blue-bg">
      <span class="g-bold g-heading-m">Actions Required</span>
    </v-card-title>

    <v-card-text
      class="py-6"
      :class="{ 'i-dialog-content-div-large': $vuetifyDisplay.mdAndUp }"
    >
      <div v-if="hasActionableOrders" class="text-center">
        <span class="g-heading-xs g-bold">Purchase Orders outstanding</span>
        <div class="p-items">
          <div
            v-if="data.purchaseOrders.newTabQty"
            class="p-item elevation-2"
            @click="handleGoTo(DRAFT)"
          >
            <span class="p-item-text">New</span>
            <v-spacer></v-spacer>
            <div v-if="data.purchaseOrders.newTabQty" class="p-item-total">
              {{ data.purchaseOrders.newTabQty }}
            </div>
          </div>
          <div
            v-if="data.purchaseOrders.inTransitTabQty"
            class="p-item elevation-2"
            @click="handleGoTo(BEFORE_DELIVERY)"
          >
            <span class="p-item-text">In Transit</span>
            <v-spacer></v-spacer>
            <div
              v-if="data.purchaseOrders.inTransitTabQty"
              class="p-item-total"
            >
              {{ data.purchaseOrders.inTransitTabQty }}
            </div>
          </div>
          <div
            v-if="data.purchaseOrders.deliveredTabQty"
            class="p-item elevation-2"
            @click="handleGoTo(DURING_DELIVERY)"
          >
            <span class="p-item-text">Delivered</span>
            <v-spacer></v-spacer>
            <div
              v-if="data.purchaseOrders.deliveredTabQty"
              class="p-item-total"
            >
              {{ data.purchaseOrders.deliveredTabQty }}
            </div>
          </div>
        </div>

        <span>Please action as soon as possible</span>
        <v-divider
          v-if="
            hasActionableOrderQueries ||
            hasActionableCreditReturns ||
            hasActionableInvites ||
            (orderChatEnabled && hasActionableSupportMessages)
          "
          class="my-8"
        ></v-divider>
      </div>

      <div v-if="hasActionableOrderQueries" class="text-center">
        <p class="text-center g-heading-xs g-bold">Order Queries</p>
        <div class="text-center mt-2 mb-2">
          <div class="p-items">
            <div class="p-item elevation-2" @click="handleGoTo(ORDER_QUERIES)">
              <span class="p-item-text">Outstanding</span>
              <v-spacer></v-spacer>
              <div class="p-item-total">
                {{ data.orderQueries.outstandingQty }}
              </div>
            </div>
          </div>
        </div>

        <span>Please action as soon as possible</span>
        <v-divider
          v-if="
            hasActionableCreditReturns ||
            hasActionableInvites ||
            (orderChatEnabled && hasActionableSupportMessages)
          "
          class="my-8"
        ></v-divider>
      </div>

      <div v-if="hasActionableCreditReturns" class="text-center">
        <p class="text-center g-heading-xs g-bold">Credit Returns</p>
        <div class="text-center mt-2 mb-2">
          <div class="p-items">
            <div class="p-item elevation-2" @click="handleGoTo(CREDIT_RETURNS)">
              <span class="p-item-text">Outstanding</span>
              <v-spacer></v-spacer>
              <div class="p-item-total">
                {{ data.creditReturns.outstandingQty }}
              </div>
            </div>
          </div>
        </div>

        <span>Please action as soon as possible</span>
        <v-divider
          v-if="
            hasActionableInvites ||
            (orderChatEnabled && hasActionableSupportMessages)
          "
          class="my-8"
        ></v-divider>
      </div>

      <div v-if="hasActionableInvites">
        <p class="text-center g-heading-xs g-bold">Turn In Orders Request</p>
        <div class="text-center mt-2 mb-2">
          <div class="p-items">
            <div class="p-item elevation-2" @click="handleGoTo(INVITES)">
              <span class="p-item-text">Pending</span>
              <v-spacer></v-spacer>
              <div class="p-item-total">
                {{ data.actionableConsents.totalQty }}
              </div>
            </div>
          </div>
          <span
            >A Retailer requests Turn In Orders to be placed in their Store.
            Action in Retailer Turn In Orders in My Account</span
          >
        </div>
      </div>

      <div
        v-if="orderChatEnabled && hasActionableSupportMessages"
        class="text-center"
      >
        <v-divider
          v-if="
            hasActionableOrders ||
            hasActionableOrderQueries ||
            hasActionableCreditReturns ||
            hasActionableInvites
          "
          class="my-8"
        ></v-divider>
        <p class="text-center g-heading-xs g-bold">Retailer support</p>
        <div class="text-center mt-2 mb-2">
          <div class="p-items">
            <div class="p-item elevation-2" @click="handleGoToSupport()">
              <span class="p-item-text">Unread messages</span>
              <v-spacer></v-spacer>
              <div class="p-item-total">
                {{ data.actionableSupportMessages.total }}
              </div>
            </div>
          </div>
          <span>
            You have unread messages across
            {{ data.actionableSupportMessages.orders }}
            {{
              data.actionableSupportMessages.orders === 1 ? 'order' : 'orders'
            }}.
          </span>
        </div>
      </div>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="i-dialog-actions-div justify-end">
      <v-btn rounded text class="i-btn-block-secondary" @click="$emit('close')">
        <strong>Close</strong>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

const PURCHASE_ORDERS_STATUSES = {
  DRAFT: 'DRAFT',
  BEFORE_DELIVERY: 'BEFORE_DELIVERY',
  DURING_DELIVERY: 'DURING_DELIVERY'
}

const INVITES = 'INVITES'
const ORDER_QUERIES = 'ORDER_QUERIES'
const CREDIT_RETURNS = 'CREDIT_RETURNS'

export default {
  name: 'alerts-dialog',

  props: {
    data: {
      default: () => {},
      type: Object
    }
  },

  data: () => ({
    INVITES,
    ORDER_QUERIES,
    CREDIT_RETURNS,
    ...PURCHASE_ORDERS_STATUSES
  }),

  computed: {
    ...mapGetters('tenant', ['orderChatEnabled']),

    hasActionableOrders() {
      return this.data.purchaseOrders?.totalQty > 0
    },

    hasActionableOrderQueries() {
      return this.data.orderQueries?.outstandingQty > 0
    },

    hasActionableCreditReturns() {
      return this.data.creditReturns?.outstandingQty > 0
    },

    hasActionableInvites() {
      return this.data.actionableConsents?.totalQty > 0
    },

    hasActionableSupportMessages() {
      return this.data.actionableSupportMessages?.total > 0
    }
  },

  methods: {
    ...mapActions('notifications', ['setAlertsAsSeen']),

    handleGoTo(routeName) {
      if (!routeName) return

      this.setAlertsAsSeen()
      if (routeName === INVITES)
        this.$router.push({
          name: 'retailer-management-for-agents',
          query: { status: 'PENDING' }
        })
      else if (routeName === ORDER_QUERIES)
        this.$router.push({ name: 'order-queries' })
      else if (routeName === CREDIT_RETURNS)
        this.$router.push({ name: 'credit-returns' })
      else
        this.$router.push({
          name: 'purchase-orders',
          query: { status: routeName }
        })
    },
    handleGoToSupport() {
      this.setAlertsAsSeen()
      this.$router.push({ name: 'order-chat-history' })
    }
  }
}
</script>

<style lang="scss" scoped>
#alerts-dialog {
  .p-items {
    max-width: 220px;
    margin: auto;
    margin-top: 18px;
    margin-bottom: 20px;
  }
  .p-item {
    align-items: center;
    background-color: white;
    border: 0px solid $blue-color;
    border-radius: 5px;
    border-bottom: 5px solid $blue-color;
    display: flex;
    padding: 4px 16px;
    margin: 16px 0px;
    transition: 200ms background-color;
    &:hover {
      background-color: hsl(0, 0%, 95%);
      cursor: pointer;
    }
    &-text {
      color: hsl(0, 0%, 30%);
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.25px;
    }
    &-total {
      background-color: orange;
      border-radius: 100px;
      color: white;
      font-size: 18px;
      font-weight: bold;
      min-width: 28px;
      padding-left: 6px;
      padding-right: 6px;
    }
  }
}

@media only screen and (min-width: 960px) {
  #alerts-dialog {
    .p-items {
      max-width: 240px;
      margin-top: 22px;
      margin-bottom: 24px;
    }
    .p-item {
      padding: 6px 16px;
      &-text {
        font-size: 20px;
        letter-spacing: 0.5px;
      }
      &-total {
        font-size: 22px;
        min-width: 34px;
        padding-left: 8px;
        padding-right: 8px;
      }
    }
  }
}
</style>
